import request from "@/yintai/utils/request";

export function fetchNews(data) {
  return request({
    url: "/news/out/list",
    method: "post",
    data,
  });
}

export function findNewsById(data) {
  return request({
    url: "/news/out/getById",
    method: "post",
    data,
  });
}
